/**
 * Job Cost Hub tab — iframes the jobcost truth view. P&L stays in the jobcost shell sub-nav.
 * Module failure must not take the Hub down.
 */
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '../../../api/client'

interface Props {
  projectId: number
  baseUrl: string
}

function Fallback() {
  return (
    <div style={{ padding: '18px 0', fontSize: 13, color: 'var(--ink3)' }}>
      Job Cost unavailable
    </div>
  )
}

export default function JobCostTab({ projectId, baseUrl }: Props) {
  const skipProxyHealth = Boolean(import.meta.env.VITE_JOBCOST_URL)
  const [frameDown, setFrameDown] = useState(false)
  const health = useQuery({
    queryKey: ['jobcost-health'],
    queryFn: () => apiFetch('GET', '/api/jobcost/health'),
    retry: false,
    staleTime: 15_000,
    enabled: !skipProxyHealth,
  })

  if (!skipProxyHealth && health.isPending) {
    return (
      <div style={{ padding: '18px 0', fontSize: 12, color: 'var(--ink4)' }}>
        Loading Job Cost…
      </div>
    )
  }
  if (frameDown || (!skipProxyHealth && health.isError)) return <Fallback />

  return (
    <iframe
      title="Job Cost"
      src={`${baseUrl.replace(/\/$/, '')}/jobcost/projects/${projectId}/truth`}
      onError={() => setFrameDown(true)}
      style={{ width: '100%', minHeight: 640, border: 0, background: 'var(--bg)' }}
    />
  )
}
